import {UseFormRegisterReturn} from "react-hook-form";
import React from "react";

type OfferedHourInputProps = {
    label: string;
    disabled: boolean;
    registered: UseFormRegisterReturn;
    error?: string | undefined;
};

export function OfferedHourInput({label, disabled, registered, error = undefined}: OfferedHourInputProps) {
    return (
        <div className="w-1/2 p-2">
            <div className="flex items-center">
                <div className="w-2/3 text-right pr-3">
                    {label}
                </div>
                <input
                    className={`block w-1/3 bg-white border border-gray-400 hover:border-atlantis-100 ` +
                        `p-2 rounded shadow leading-tight focus:outline-none focus:shadow-outline ${disabled ? 'bg-gray-100 opacity-50 pointer-events-none' : ''}`}
                    autoComplete='off'
                    disabled={disabled}
                    {...registered}
                />
            </div>

            {
                error && (
                    <div className="text-red-700 text-right pt-1">
                        {error}
                    </div>
                )
            }
        </div>
    );
}
